import {
  Table,
  TableCell,
  TableHead,
  TableRow,
  TableBody,
  CircularProgress,
  Box,
  TableContainer,
  Stack,
  Button,
  Typography,
} from "@mui/material";
import { grey } from "@mui/material/colors";
import dayjs from "dayjs";
import React, { useEffect, useState } from "react";
import { useOutletContext, useRouteLoaderData } from "react-router-dom";
import { BACKEND_URL } from "../../helpers/variable";
import { useFormContext } from "../../component/FormContext";
import { enqueueSnackbar } from "notistack";
import { months } from "../../component/Header";
import { useAction } from "../../component/ActionContext";
import { validateToken } from "../../API/nimble";

const ScoreReport = () => {
  const { autoFetch, urlInfo, clientNameUrlVersion } = useRouteLoaderData("layout");
  const { PCS } = useOutletContext();
  const { setActions } = useAction();



  const { formValues } = useFormContext();
  const { corporation, pc, year, month, readyToFetch } = formValues;

  const [scoreData, setScoreData] = useState();
  const [loading, setLoading] = useState(false);

  const fetchCondition =
    year === "" ||
    month === "" ||
    !corporation ||
    (PCS.length > 0 && pc === "");

  useEffect(() => {
    if (autoFetch && !fetchCondition && readyToFetch) {
      console.log("inside useEffect")
      getScoreData();
    }
  }, [autoFetch, fetchCondition, readyToFetch]);

  async function getScoreData() {


    if (corporation.ID === "" && corporation.Name === "--select--") {
      enqueueSnackbar("Please select the Corporation from the list", {
        variant: "error",
      });
      return;
    }
    if (fetchCondition) {
      enqueueSnackbar("Missing required field: profit center ", {
        variant: "error",
      });
      return;
    }

    setLoading(true);

    const tokenValidate = await validateToken(clientNameUrlVersion);
    if (!tokenValidate) { return; }


    let res = await fetch(`${BACKEND_URL}/custom_report_scorecard`, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
      },
      body: JSON.stringify({
        year,
        month: String(months.indexOf(month) + 1),
        corporation_id: corporation?.ID,
        profit_center_id: pc,
      }),
    });

    if (res.status === 200) {
      const data = await res.json();
      Object.values(data["scorecard_responses"]).forEach((values) => {
        const responses = values.survey_responses;
        if (responses) {
          Object.entries(responses).forEach(([key, innerObj]) => {
            if (innerObj?.["Review Sites5pt scale"]) {
              delete innerObj["Review Sites5pt scale"];
            }
          });
        }
      });
      setScoreData(data);
    } else if (res.status === 204) {
      enqueueSnackbar("No Data Found", {
        variant: "error",
      });
      setScoreData([]);
    }

    setLoading(false);
  }

  // const checkIfTotalExists = (week) => {
  //   const sampleObj = Object.values(week.survey_responses || {})
  //     .flatMap((inner) => Object.values(inner))
  //     .find((obj) => obj?.total_value !== undefined);

  //   return sampleObj?.total_value !== undefined;
  // };
  const checkIfTotalExists = (week) => {
        const surveyObj = Object.values(week.survey_responses || {})
      .flatMap(inner => {
        if (inner && typeof inner === "object" && "total_value" in inner) {
          return [inner];
        }
        return Object.values(inner || {});
      })
      .find(obj => obj?.total_value !== undefined);

    if (surveyObj) return true;

    const reviewObj = Object.values(week.review_responses || {})
      .flatMap(inner => Object.values(inner))
      .flatMap(metric => {
        if (metric && typeof metric === "object" && "total_value" in metric) {
          return [metric];
        }
        return Object.values(metric || {});
      })
      .find(obj => obj?.total_value !== undefined);

    return reviewObj !== undefined;
  };


  const checkIfTotalExistsInReview = (week, section) => {
    const metricData = Object.values(
      week.review_responses?.[section] || {}
    ).find((val) => val?.total_value !== undefined);
    return metricData?.total_value !== undefined;
  };

  const formatWeek = (startDate) =>
    `Week of ${dayjs(startDate).format("DD MMM")}`;
  const formatDay = (date) => dayjs(date).format("DD ddd");

  const formatMonth = (date) =>
    dayjs(date).format("MMM YYYY");

  const surveyResponses = scoreData?.scorecard_responses?.[0]?.survey_responses;

  useEffect(() => {
    setActions(
      <Button variant="contained" onClick={getScoreData}>
        Submit
      </Button>
    );
  }, [formValues, PCS]);

  return (
    <>
      {loading ? (
        <Box height={"100%"} display={"grid"} sx={{ placeItems: "center" }}>
          <CircularProgress />
        </Box>
      ) : scoreData?.length === 0 ? (
        <Box
          height="100%"
          display="flex"
          justifyContent="center"
          alignItems="center"
        >
          <Typography variant="body1">No Data Found</Typography>
        </Box>
      ) : (
        scoreData && (
          <TableContainer>
            <Table
              size="small"
              sx={{
                "& td": {
                  whiteSpace: "nowrap",
                },
                tableLayout: "auto",

                "& .MuiTableCell-root": {
                  padding: "2px 3px",
                  lineHeight: 1.1,
                },
              }}
            >
              <TableHead
                sx={{
                  "& th": {
                    whiteSpace: "nowrap",
                    fontWeight: "bold",
                  },
                }}
              >
                <TableRow
                  sx={{
                    "& th": {
                      bgcolor: grey[400],
                    },
                  }}
                >
                  <TableCell>Reports</TableCell>
                  {scoreData.scorecard_responses.map((week, index) => {
                    const isTotal = checkIfTotalExists(week);
                    // const hasWeekData =
                    //   dayjs(week.timestamps.end_time).diff(
                    //     dayjs(week.timestamps.start_time),
                    //     "day"
                    //   ) >= 6;
                    // const hasMonthData =
                    //   dayjs(week.timestamps.end_time).diff(
                    //     dayjs(week.timestamps.start_time),
                    //     "day"
                    //   ) >= 28;

                    // const weekRange = hasWeekData
                    //   ? formatWeek(week.timestamps.start_time)
                    //   : formatDay(week.timestamps.start_time);

                    const diffInDays = dayjs(week.timestamps.end_time).diff(
                      dayjs(week.timestamps.start_time),
                      "day"
                    );


                    const hasMonthData = diffInDays >= 27;

                    const hasWeekData = diffInDays >= 6 && diffInDays < 28;


                    const weekRange = hasMonthData
                      ? formatMonth(week.timestamps.start_time)
                      : hasWeekData
                        ? formatWeek(week.timestamps.start_time)
                        : formatDay(week.timestamps.start_time);

                    return isTotal ? (
                      <React.Fragment key={`total-${index}`}>
                        <TableCell
                          align="center"
                          sx={{ backgroundColor: "#e3f2fd !important" }}
                        >
                          Total
                        </TableCell>
                        <TableCell colSpan={2} align="center">
                          Benchmark
                        </TableCell>
                      </React.Fragment>
                    ) : (
                      <TableCell key={`week-${index}`} align="center">
                        {weekRange}
                      </TableCell>
                    );
                  })}
                </TableRow>

                <TableRow>
                  <TableCell />
                  {scoreData.scorecard_responses.map((week, index) => {
                    const isTotal = checkIfTotalExists(week);
                    return isTotal ? (
                      <React.Fragment key={`benchmark-${index}`}>
                        <TableCell
                          align="center"
                          sx={{ backgroundColor: "#e3f2fd !important" }}
                        >
                          value
                        </TableCell>
                        <TableCell align="center">Year Ago</TableCell>
                        <TableCell align="center">Variance</TableCell>
                      </React.Fragment>
                    ) : (
                      <TableCell key={`empty-${index}`} colSpan={1} />
                    );
                  })}
                </TableRow>
              </TableHead>

              <TableBody>
                {surveyResponses &&
                  Object.entries(surveyResponses).map(
                    ([sectionName, metricsObj]) => (
                      <React.Fragment key={sectionName}>
                        <TableRow>
                          <TableCell
                            colSpan={
                              1 +
                              scoreData.scorecard_responses.reduce(
                                (acc, week) => {
                                  const isTotal = checkIfTotalExists(week);
                                  return acc + (isTotal ? 3 : 1);
                                },
                                0
                              )
                            }
                            sx={{
                              fontWeight: "bold",
                              fontSize: "16px",
                              bgcolor: grey[100],
                            }}
                          >
                            {sectionName}
                          </TableCell>
                        </TableRow>

                        {Object.entries(metricsObj).map(([metricName, _]) => (
                          <TableRow key={metricName}>
                            <TableCell>{metricName}</TableCell>

                            {scoreData.scorecard_responses.map(
                              (week, index) => {
                                const metricData =
                                  week.survey_responses?.[sectionName]?.[
                                  metricName
                                  ];
                                const isTotal = checkIfTotalExists(week);

                                return isTotal ? (
                                  <React.Fragment key={index}>
                                    <TableCell
                                      align="center"
                                      sx={{
                                        backgroundColor: " #e3f2fd !important",
                                        fontWeight: 600,
                                      }}
                                    >
                                      {metricData?.total_value ?? "-"}
                                    </TableCell>
                                    <TableCell align="center">
                                      {metricData?.yearago_value ?? "-"}
                                    </TableCell>
                                    <TableCell align="center">
                                      {metricData?.variance ?? "-"}
                                    </TableCell>
                                  </React.Fragment>
                                ) : (
                                  <TableCell align="center" key={index}>
                                    {metricData?.value ?? "-"}
                                  </TableCell>
                                );
                              }
                            )}
                          </TableRow>
                        ))}
                      </React.Fragment>
                    )
                  )}

                {scoreData.scorecard_responses?.[0]?.review_responses &&
                  Object.entries(
                    scoreData.scorecard_responses?.[0]?.review_responses
                  ).map(([sectionName, metricsObj]) => (
                    <React.Fragment key={sectionName}>
                      <TableRow>
                        <TableCell
                          colSpan={
                            1 +
                            scoreData.scorecard_responses.reduce(
                              (acc, week) => {
                                const isTotalInReview =
                                  checkIfTotalExistsInReview(week, sectionName);
                                const isTotalInSurvey =
                                  checkIfTotalExists(week);
                                const isTotal =
                                  isTotalInReview || isTotalInSurvey;
                                return acc + (isTotal ? 3 : 1);
                              },
                              0
                            )
                          }
                          sx={{
                            fontWeight: "bold",
                            bgcolor: grey[100],
                            fontSize: "16px",
                          }}
                        >
                          {sectionName}
                        </TableCell>
                      </TableRow>

                      {Object.entries(metricsObj).map(([metricName, _]) => {
                        const isResponseMetric = ["Sample size", "# of responses"].includes(metricName);

                        return (
                          <TableRow key={metricName}>
                            <TableCell
                              sx={{
                                color:
                                  isResponseMetric
                                    ? "lightgrey"
                                    : "inherit",
                              }}
                            >
                              {metricName}
                            </TableCell>
                            {scoreData.scorecard_responses.map((week, index) => {
                              const metricData =
                                week.review_responses?.[sectionName]?.[
                                metricName
                                ];
                              const isTotalInReview = checkIfTotalExistsInReview(
                                week,
                                sectionName
                              );
                              const isTotalInSurvey = checkIfTotalExists(week);
                              const isTotal = isTotalInReview || isTotalInSurvey;


                              return isTotal ? (
                                <React.Fragment key={index}>
                                  <TableCell
                                    align="center"
                                    sx={{
                                      backgroundColor: " #e3f2fd !important",
                                      fontWeight: 600,
                                      color:
                                        isResponseMetric
                                          ? "lightgrey"
                                          : "inherit",
                                    }}
                                  >
                                    {metricData?.total_value ?? "-"}
                                  </TableCell>
                                  <TableCell
                                    align="center"
                                    width={150}
                                    sx={{
                                      textAlign:
                                        (isResponseMetric && metricData?.variance === null)
                                          ? "end"
                                          : "center",
                                      color:
                                        isResponseMetric
                                          ? "grey"
                                          : "inherit",
                                    }}
                                  >
                                    {metricData?.yearago_value ?? "-"}
                                  </TableCell>
                                  <TableCell
                                    align="center"
                                    sx={{
                                      color:
                                        isResponseMetric
                                          ? "lightgrey"
                                          : "inherit",
                                    }}
                                  >
                                    {metricData?.variance ?? "-"}
                                  </TableCell>
                                </React.Fragment>
                              ) : (
                                <TableCell
                                  align="center"
                                  key={index}
                                  sx={{
                                    color:
                                      isResponseMetric
                                        ? "lightgrey"
                                        : "inherit",
                                  }}
                                >
                                  {metricData?.value ?? "-"}
                                </TableCell>
                              );
                            })}
                          </TableRow>
                        )
                      }

                      )}
                    </React.Fragment>
                  ))}
              </TableBody>
            </Table>
          </TableContainer>
        )
      )}
    </>
  );
};

export default ScoreReport;
